export default __webpack_public_path__ + "static/media/PokemonDashboard.b8f3bca3.png";